import { useEffect, useState } from 'react';
import { getMeetingInfoLocalServer } from 'api/zoom';

interface IParams {
    providerId?: string;
    //isOps?:boolean;
}

// {
//     "roomId": "138-010-770",
//     "sessionName": "b6153714-0c61-4fe4-8212-d6338d03fe49",
//     "hostToken": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHBfa2V5IjoiWjl0dVF3Rmd2cVZkdU9ubXRzaEZJRlBXSjdrenNCcVF4SDY5IiwidHBjIjoiYjYxNTM3MTQtMGM2MS00ZmU0LTgyMTItZDYzMzhkMDNmZTQ5Iiwicm9sZV90eXBlIjoxLCJ1c2VyX2lkZW50aXR5IjoiaG9zdF8xNzY0NjU5NDEzOTc2IiwidmVyc2lvbiI6MSwiaWF0IjoxNzY0NjU5NDEzLCJleHAiOjE3NjQ2NjMwMTN9.K9M-TUnEzfRTUixQI5_1UY58jXiAS84CVc7C91tfx0k",
//     "participantToken": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHBfa2V5IjoiWjl0dVF3Rmd2cVZkdU9ubXRzaEZJRlBXSjdrenNCcVF4SDY5IiwidHBjIjoiYjYxNTM3MTQtMGM2MS00ZmU0LTgyMTItZDYzMzhkMDNmZTQ5Iiwicm9sZV90eXBlIjowLCJ1c2VyX2lkZW50aXR5IjoicGFydGljaXBhbnRfMTc2NDY1OTQxMzk3OCIsInZlcnNpb24iOjEsImlhdCI6MTc2NDY1OTQxMywiZXhwIjoxNzY0NjYzMDEzfQ.qSz51D4w94Oe3MBWc2COAYyV8_3QAGT4kcDXy9TajLo",
//     "participantPassword": "PDCBR5",
//     "hostJoinUrl": "http://localhost:3000/138-010-770?sk=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHBfa2V5IjoiWjl0dVF3Rmd2cVZkdU9ubXRzaEZJRlBXSjdrenNCcVF4SDY5IiwidHBjIjoiYjYxNTM3MTQtMGM2MS00ZmU0LTgyMTItZDYzMzhkMDNmZTQ5Iiwicm9sZV90eXBlIjoxLCJ1c2VyX2lkZW50aXR5IjoiaG9zdF8xNzY0NjU5NDEzOTc2IiwidmVyc2lvbiI6MSwiaWF0IjoxNzY0NjU5NDEzLCJleHAiOjE3NjQ2NjMwMTN9.K9M-TUnEzfRTUixQI5_1UY58jXiAS84CVc7C91tfx0k&name=2",
//     "participantJoinUrl": "http://localhost:3000/room/138-010-770?pwd=PDCBR5",
//     "topic": "1",
//     "duration": 60,
//     "createdAt": 1764659413979,
//     "expiresAt": 1764663013979
// }

type TZoomMeetingInfo = {
    roomId: string;
    sessionName: string;
    hostToken: string;
    participantToken: string;
    participantPassword: string;
    hostJoinUrl: string;
    participantJoinUrl: string;
    topic: string;
    duration: number;
    createdAt: number;
    expiresAt: number;
};

// curl 'http://localhost:4000/api/meeting' \
//   -H 'Accept: application/json, text/plain, */*' \
//   -H 'Accept-Language: en-GB,en-US;q=0.9,en;q=0.8,zh-CN;q=0.7,zh;q=0.6' \
//   -H 'Cache-Control: no-cache' \
//   -H 'Connection: keep-alive' \
//   -H 'Content-Type: application/json' \
//   -H 'Origin: http://localhost:3000' \
//   -H 'Pragma: no-cache' \
//   -H 'Referer: http://localhost:3000/' \
//   -H 'Sec-Fetch-Dest: empty' \
//   -H 'Sec-Fetch-Mode: cors' \
//   -H 'Sec-Fetch-Site: same-site' \
//   -H 'User-Agent: Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/142.0.0.0 Safari/537.36' \
//   -H 'sec-ch-ua: "Chromium";v="142", "Google Chrome";v="142", "Not_A Brand";v="99"' \
//   -H 'sec-ch-ua-mobile: ?0' \
//   -H 'sec-ch-ua-platform: "macOS"' \
//   --data-raw '{"topic":"1","hostName":"2"}'

const useLocalTestZoomMeetingInfo = (): [TZoomMeetingInfo | undefined, boolean, (id: string) => void] => {
    const [data, setData] = useState<TZoomMeetingInfo>();
    const [loading, setLoading] = useState(false);
    const fetchData = async () => {
        setLoading(true);
        const res = await getMeetingInfoLocalServer('Evan', 'Say hi');
        if (!res.error) {
            setData(res?.data);
        }
        setLoading(false);
    };

    useEffect(() => {
        fetchData();
    }, []);

    return [data, loading, fetchData];
};

export default useLocalTestZoomMeetingInfo;
